function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 4.018C14.476 4.018 10 8.476 10 13.998C10 23.546 20 35.998 20 35.998C20 35.998 30 23.544 30 13.998C30 8.478 25.524 4.018 20 4.018V4.018ZM20 19.52C18.5678 19.52 17.1943 18.9511 16.1816 17.9384C15.1689 16.9257 14.6 15.5522 14.6 14.12C14.6 12.6878 15.1689 11.3143 16.1816 10.3016C17.1943 9.28893 18.5678 8.72 20 8.72C21.4322 8.72 22.8057 9.28893 23.8184 10.3016C24.8311 11.3143 25.4 12.6878 25.4 14.12C25.4 15.5522 24.8311 16.9257 23.8184 17.9384C22.8057 18.9511 21.4322 19.52 20 19.52Z",
  fill: "#A0AEC0"
});

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.47873b80.svg";
export { ForwardRef as ReactComponent };